export default "__VITE_ASSET__O1OqS7Ah__"